var req = require("!!/__w/30/s/node_modules/pug-loader/index.js!/__w/30/s/src/app/health-wellness/soundscaping/soundscaping.component.pug");
module.exports = (req['default'] || req).apply(req, [])